import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './self-exclude.magic.css.js';
import script from './self-exclude.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-exclude",attrs:{"part":"self-exclude","data-v-test-id":"self-exclude"}},[_c('form',{staticClass:"form",attrs:{"part":"form"}},[_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","data-v-test-id":"self-exclude-text","content":_vm.$t('self-exclude.introduction')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h3","part":"title","content":_vm.$t('self-exclude.radio-group.title')}}),_vm._v(" "),_c('magic-ui-radio-group',{staticClass:"radio-group",attrs:{"part":"radio-group","data-v-test-id":"self-exclude-radio-group","value":(_vm.selectedDuration)},on:{"change":function($event){_vm.selectedDuration=$event.detail[0];}}},[_c('div',{staticClass:"spacer",attrs:{"part":"spacer"}}),_vm._v(" "),_vm._l((_vm.durations),function(duration){return _c('magic-ui-radio',{key:duration,staticClass:"radio",attrs:{"part":"radio","id":duration,"value":duration},domProps:{"innerHTML":_vm._s(_vm.getDurationLabel(duration))}})})],2),_vm._v(" "),_c('magic-ui-checkbox',{staticClass:"checkbox",attrs:{"inline":"","id":"checkbox","part":"checkbox","data-v-test-id":"self-exclude-checkbox","value":(_vm.confirmation)},domProps:{"innerHTML":_vm._s(_vm.$t('self-exclude.user-confirmation.label'))},on:{"change":function($event){_vm.confirmation=$event.detail[0];}}}),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-button',{attrs:{"wide":"","variant":"primary","data-v-test-id":"self-exclude-submit","disabled":!_vm.confirmation || !_vm.selectedDuration},domProps:{"innerHTML":_vm._s(_vm.$t('self-exclude.button'))},on:{"click":function($event){return _vm.selfExclude()}}})],1)],1)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-750960de_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-750960de";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
